import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { createGtmInteractor } from './gtmInteractor';
import * as events from './events';

const DATALAYER_NAME = getPublicRuntimeConfig('DATALAYER_NAME');

const createEventDispatcher = (dataLayerName: string) => {
  const gtmInteractor = createGtmInteractor(dataLayerName);
  return {
    addToWishlist: events.addToWishlist(gtmInteractor),
    removeFromWishlist: events.removeFromWishlist(gtmInteractor),
    pageLoad: events.pageLoad(gtmInteractor),
    sessionStart: events.sessionStart(gtmInteractor),
    initial: events.gtmStart(gtmInteractor),
    marketing: events.marketing(gtmInteractor),
    productClickout: events.productClickout(gtmInteractor),
    productLoadMore: events.productLoadMore(gtmInteractor),
    productLoadComplete: events.productLoadComplete(gtmInteractor),
    productSearchStateUpdate: events.productSearchStateUpdate(gtmInteractor),
    recommendationRequest: events.recommendationRequest(gtmInteractor),
    cmsModuleEvent: events.cmsModuleEvent(gtmInteractor),
    merchantAdLoaded: events.merchantAdLoaded(gtmInteractor),
    merchantAdClickedInternal: events.merchantAdClickedInternal(gtmInteractor),
    merchantAdClickedExternal: events.merchantAdClickedExternal(gtmInteractor),
    newsletterRegistered: events.newsletterRegistered(gtmInteractor),
    ucAcceptedAllOnFirstLayer: events.ucAcceptedAllOnFirstLayer(gtmInteractor),
    ucCloseAndAcceptedAllOnFirstLayer: events.ucCloseAndAcceptedAllOnFirstLayer(gtmInteractor),
    ucAcceptedAllOnSecondlayer: events.ucAcceptedAllOnSecondlayer(gtmInteractor),
    ucCloseAndAcceptedAllOnSecondLayer: events.ucCloseAndAcceptedAllOnSecondLayer(gtmInteractor),
    ucSettingsOpened: events.ucSettingsOpened(gtmInteractor),
    ucSettingsSaved: events.ucSettingsSaved(gtmInteractor),
  };
};

export const gtmEventDispatcher = createEventDispatcher(DATALAYER_NAME);
